import React from 'react';
import { process as processContent, contact } from '../../content';
import { Button } from '../ui/button';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { getWhatsAppLink } from '../../content/contentUtils';

// Valores por defecto
const defaultProcess = {
  sectionLabel: "Proceso simple",
  sectionTitle: "Obtén tu crédito en 3 pasos",
  sectionSubtitle: "Rápido y con asesoría personalizada",
  steps: [],
  buttons: { primary: "Inicia tu solicitud", secondary: "Habla con un asesor" }
};

export const ProcessSection = () => {
  // Obtener contenido con fallbacks
  const content = {
    sectionLabel: processContent?.sectionLabel || defaultProcess.sectionLabel,
    sectionTitle: processContent?.sectionTitle || defaultProcess.sectionTitle,
    sectionSubtitle: processContent?.sectionSubtitle || defaultProcess.sectionSubtitle,
    steps: processContent?.steps || defaultProcess.steps,
    buttons: processContent?.buttons || defaultProcess.buttons
  };

  if (content.steps.length === 0) return null;

  return (
    <section className="py-24 bg-[#013C5D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#CFA935] font-semibold text-sm uppercase tracking-wider">
            {content.sectionLabel}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-white">
            {content.sectionTitle}
          </h2>
          <p className="mt-4 text-white/70 text-lg">
            {content.sectionSubtitle}
          </p>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-3 gap-6">
          {content.steps.map((step, idx) => (
            <div key={step.id || idx} className="relative">
              {/* Connector line */}
              {idx < content.steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-[#CFA935]/30 z-0" />
              )}

              <div className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 transition-all group">
                {/* Step number */}
                <div className="w-12 h-12 rounded-full bg-[#CFA935] text-[#013C5D] font-bold text-lg flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  {step.step}
                </div>

                <h3 className="text-white text-lg font-semibold mb-2">
                  {step.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4">
            <a href={getWhatsAppLink("Hola, quiero iniciar mi solicitud de crédito")} target="_blank" rel="noopener noreferrer">
              <Button
                size="lg"
                className="bg-[#CFA935] hover:bg-[#b8942f] text-[#013C5D] font-semibold px-8 h-14"
              >
                {content.buttons.primary}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
            </a>
            <a href={getWhatsAppLink()} target="_blank" rel="noopener noreferrer">
              <Button
                size="lg"
                variant="outline"
                className="border-2 border-white/30 text-white hover:bg-white hover:text-[#013C5D] font-semibold px-8 h-14"
              >
                <MessageCircle className="mr-2 w-5 h-5" />
                {content.buttons.secondary}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
